import { AuthenticatedApiClient } from '@guiker/booking-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useBookingApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
